export default {
  type: "Feature",
  properties: {
    name: "Баянгол",
    location: [48.91312, 106.0898],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.870944187624, 47.9419650841214],
        [106.871601162164, 47.9423815592616],
        [106.874054129594, 47.9439365653203],
        [106.874055555919, 47.9439444442807],
        [106.874227277867, 47.9439485982493],
        [106.874282347852, 47.9439422148614],
        [106.874338783009, 47.9439323492985],
        [106.87439718768, 47.943918899038],
        [106.874458742677, 47.9439015960818],
        [106.874555547501, 47.9438692708502],
        [106.874783531035, 47.9437832273142],
        [106.87488804125, 47.9437475125378],
        [106.875324728653, 47.9436079134745],
        [106.87615041511, 47.9433358199922],
        [106.877102441924, 47.9430250754469],
        [106.877636361329, 47.9428480358082],
        [106.878122909844, 47.9426864303346],
        [106.878262826368, 47.9426380360166],
        [106.878387008354, 47.9425931490546],
        [106.878594820994, 47.9425137407166],
        [106.878814767288, 47.9424249920198],
        [106.878917674012, 47.9423815592616],
        [106.87905200035, 47.9423248651005],
        [106.879326822375, 47.9422048029094],
        [106.87945908387, 47.9421449449333],
        [106.879888680119, 47.941945753194],
        [106.880222876285, 47.9417990611778],
        [106.880418897914, 47.9417136750461],
        [106.880519894478, 47.9416674597855],
        [106.88067871565, 47.9415888167705],
        [106.880934053864, 47.9414580427545],
        [106.881020598322, 47.9414100612254],
        [106.881096322138, 47.9413647138106],
        [106.881179267509, 47.9413099109237],
        [106.881338163326, 47.9411978050347],
        [106.881622037927, 47.9410012384164],
        [106.881895665653, 47.9408193226537],
        [106.882041076135, 47.9407230034639],
        [106.882116615589, 47.9406708598723],
        [106.882219328959, 47.9405967629303],
        [106.882222839912, 47.9405939732333],
        [106.882284492036, 47.9405449934567],
        [106.882343413818, 47.9404922698025],
        [106.882393915247, 47.9404418097418],
        [106.882432620269, 47.9403982870514],
        [106.882471417022, 47.9403500141419],
        [106.882524734229, 47.9402727398951],
        [106.882588586094, 47.9401634201058],
        [106.882640734183, 47.9400604108593],
        [106.882733470473, 47.9398496349527],
        [106.882752751938, 47.939808107858],
        [106.882933387066, 47.9394190755299],
        [106.883078266949, 47.9391052903769],
        [106.88318597875, 47.938865588676],
        [106.883232683242, 47.9387616513292],
        [106.883332031348, 47.9385253841392],
        [106.883454968672, 47.9382010949047],
        [106.883550991985, 47.9379462827948],
        [106.88360206988, 47.9378003677928],
        [106.883683893797, 47.9375310703027],
        [106.883726158336, 47.9374180848767],
        [106.883817203901, 47.9371957472859],
        [106.883923189903, 47.9369251439803],
        [106.883980194331, 47.9367875171302],
        [106.884135042298, 47.93645184068],
        [106.884165207358, 47.9363789830037],
        [106.884249345231, 47.9361586383106],
        [106.884280832295, 47.9360896063503],
        [106.884313657549, 47.9360288697366],
        [106.88438264904, 47.9359225159114],
        [106.884482692322, 47.9357871076889],
        [106.88454444517, 47.9357096194034],
        [106.884658162644, 47.9355742066844],
        [106.884811058184, 47.9353884364273],
        [106.884901008375, 47.9352877798072],
        [106.884978421117, 47.9352103670648],
        [106.88506903231, 47.9351269594417],
        [106.885170278885, 47.9350392143883],
        [106.885344674517, 47.9348930439788],
        [106.885444965113, 47.9348109646543],
        [106.88573212224, 47.9345825143716],
        [106.885972098234, 47.9343852921476],
        [106.886119040262, 47.934257507478],
        [106.886227756606, 47.9341562204333],
        [106.886342965156, 47.9340438078755],
        [106.886446910597, 47.9339394829208],
        [106.886514353455, 47.9338671828243],
        [106.886601398836, 47.9337635008849],
        [106.886689544987, 47.9336470413779],
        [106.886739660607, 47.9335738257715],
        [106.886834455446, 47.9334256183976],
        [106.88697043204, 47.9332210693969],
        [106.887035724619, 47.9331180763382],
        [106.887087296242, 47.9330299382811],
        [106.887141437228, 47.9329306144563],
        [106.887335569381, 47.9325510726739],
        [106.887366679629, 47.9324922471196],
        [106.887452498334, 47.9323190161098],
        [106.887624059303, 47.9319430284481],
        [106.88770308363, 47.9317793572316],
        [106.887825368046, 47.931537034007],
        [106.887899218574, 47.9313957738959],
        [106.887972020492, 47.931264776848],
        [106.888042432013, 47.9311475897895],
        [106.888136800573, 47.931000492179],
        [106.888214214215, 47.9308896507368],
        [106.888300319804, 47.9307784126937],
        [106.888404083582, 47.9306546075242],
        [106.888490896937, 47.9305559195201],
        [106.888567417552, 47.9304729597593],
        [106.888599795844, 47.930439889889],
        [106.888640375953, 47.9303984419346],
        [106.888711492541, 47.9303306582333],
        [106.888791757933, 47.9302599859097],
        [106.888883031926, 47.9301853214955],
        [106.888987537645, 47.9301047233544],
        [106.889122363107, 47.9300050074252],
        [106.889376870346, 47.9298276017624],
        [106.889741936641, 47.9295759291858],
        [106.889919684046, 47.9294533920605],
        [106.89036650591, 47.9291446817817],
        [106.890607730163, 47.9289811202825],
        [106.890778697579, 47.9288693579346],
        [106.891184228869, 47.9286106463643],
        [106.891378873636, 47.9284813832093],
        [106.891484216623, 47.928407757512],
        [106.891597303673, 47.9283256952747],
        [106.892121361112, 47.9279292120635],
        [106.892250181801, 47.9278348803755],
        [106.892368073928, 47.927751924212],
        [106.892577756259, 47.9276118503067],
        [106.89299222681, 47.9273453119367],
        [106.893161722036, 47.9272340666989],
        [106.893496240159, 47.927009293744],
        [106.89373399213, 47.9268449192577],
        [106.893883767922, 47.9267366139036],
        [106.894249622922, 47.9264621884793],
        [106.894420326837, 47.9263381647746],
        [106.894646304883, 47.9261821117151],
        [106.894903573941, 47.9260115561884],
        [106.895145192097, 47.9258557918114],
        [106.895791942244, 47.9254439994411],
        [106.896271359136, 47.9251383288708],
        [106.896470128194, 47.9250096934426],
        [106.896694337274, 47.9248601029114],
        [106.897156560027, 47.9245443689275],
        [106.897357435297, 47.9244091945288],
        [106.897781298368, 47.9241332429548],
        [106.897951150625, 47.9240196702716],
        [106.898214705045, 47.9238398553251],
        [106.898295477654, 47.9237812851782],
        [106.898365479983, 47.9237271334005],
        [106.89848772303, 47.9236241232547],
        [106.898620880249, 47.9235023172782],
        [106.898722142113, 47.92340289183],
        [106.898849128185, 47.923270715771],
        [106.899024406951, 47.9230797744121],
        [106.899174639598, 47.9229037033433],
        [106.899290690813, 47.9227563197484],
        [106.899404693372, 47.9226006372097],
        [106.899517355941, 47.9224356844593],
        [106.899629880914, 47.9222597051213],
        [106.899725867355, 47.9220948611889],
        [106.899761604614, 47.9220369322587],
        [106.899834303111, 47.9219328690067],
        [106.899955275416, 47.9217733904297],
        [106.899989631316, 47.9217287040165],
        [106.900030941675, 47.9216901662682],
        [106.900091324855, 47.9216421748466],
        [106.900361111576, 47.9214722218656],
        [106.900107007233, 47.9212974458205],
        [106.900013571269, 47.921223919948],
        [106.899924956572, 47.9211550066983],
        [106.899871909161, 47.9211042723443],
        [106.899837808668, 47.9210626076533],
        [106.899798369799, 47.9210022649426],
        [106.899731694062, 47.9208970172835],
        [106.899427533454, 47.9204062608403],
        [106.89915810826, 47.9199743632263],
        [106.898780461349, 47.9193190371439],
        [106.898498677672, 47.9188670100046],
        [106.898427583566, 47.9187680890761],
        [106.898383785683, 47.9187156370171],
        [106.898344921481, 47.9186709245236],
        [106.898296644075, 47.9186232379721],
        [106.898241161301, 47.9185694153463],
        [106.89815459346, 47.9184926474178],
        [106.897817129157, 47.9182354736882],
        [106.897273584309, 47.9178143580463],
        [106.896739405, 47.917394648944],
        [106.895922754032, 47.9167575152472],
        [106.895235792498, 47.91623084168],
        [106.894955472917, 47.9160086893496],
        [106.894902322085, 47.9159548262543],
        [106.894856147293, 47.9159008480457],
        [106.894821711353, 47.9158498052244],
        [106.894794308111, 47.9158002094122],
        [106.894776035686, 47.9157457698515],
        [106.894764793261, 47.9156927799979],
        [106.89475989915, 47.9156224808928],
        [106.894757143627, 47.9155364193703],
        [106.894750001212, 47.9151666667083],
        [106.89473348876, 47.9147668110395],
        [106.89472989327, 47.9141757181349],
        [106.894702165373, 47.9134676117409],
        [106.894696607562, 47.9132658092697],
        [106.894668206972, 47.9122346627995],
        [106.894499999575, 47.9091111104894],
        [106.896499735674, 47.9089380512501],
        [106.89690915923, 47.908896121259],
        [106.897722709336, 47.9087696406065],
        [106.898120562214, 47.9087178504485],
        [106.898523341579, 47.908698631037],
        [106.900634123266, 47.9085958825939],
        [106.903986836324, 47.9084469018031],
        [106.909000350786, 47.9082843592358],
        [106.91305555487, 47.908166665859],
        [106.91240537201, 47.9066681893855],
        [106.912213415317, 47.9066949945784],
        [106.91216878736, 47.9066991854191],
        [106.912112115682, 47.90670155873],
        [106.912017795685, 47.9067006917836],
        [106.911945661063, 47.9066949846858],
        [106.911833920299, 47.9066805910365],
        [106.911794856448, 47.9066789569683],
        [106.911730492868, 47.9066786547961],
        [106.911636380615, 47.9066798122236],
        [106.911484135285, 47.9066851955654],
        [106.911301000041, 47.9066947877343],
        [106.911223458696, 47.9066968507791],
        [106.911143773367, 47.9066965018421],
        [106.911081934184, 47.9066943308787],
        [106.911015729692, 47.9066894259763],
        [106.910947299378, 47.9066819427175],
        [106.910886232714, 47.9066734243391],
        [106.910834230316, 47.9066643178041],
        [106.910720802423, 47.9066369460383],
        [106.910460878567, 47.9065705607828],
        [106.910208385808, 47.9065089284443],
        [106.90984255509, 47.9064223588049],
        [106.909611896972, 47.9063627994037],
        [106.909359226147, 47.9062962909411],
        [106.909227319885, 47.9062594708979],
        [106.909131745334, 47.906224486371],
        [106.90898462614, 47.9061684127421],
        [106.908859340686, 47.9061144147485],
        [106.908794198294, 47.906082265784],
        [106.90874103577, 47.9060529856568],
        [106.908666759863, 47.9060054537887],
        [106.908592304092, 47.9059530493938],
        [106.908535605434, 47.9059103001203],
        [106.908491493688, 47.9058742597893],
        [106.908431445055, 47.9058191772133],
        [106.908407758711, 47.9058012834026],
        [106.908390504318, 47.905790597658],
        [106.908372817352, 47.9057828212203],
        [106.90832799694, 47.9057672539557],
        [106.908270095888, 47.9057432708353],
        [106.908235778658, 47.9057248967866],
        [106.908204445379, 47.9057024910771],
        [106.908183429122, 47.9056818768172],
        [106.908170682131, 47.9056625629769],
        [106.908160070131, 47.9056383757105],
        [106.908151299043, 47.905597069849],
        [106.90814489677, 47.9055215888503],
        [106.908142506372, 47.9054828559491],
        [106.908139123122, 47.9054631652929],
        [106.908123104398, 47.9054219790411],
        [106.90810762077, 47.9053954148666],
        [106.908091577764, 47.905379951024],
        [106.908062786868, 47.9053595858762],
        [106.90803171709, 47.9053412073309],
        [106.907977728989, 47.9053146710353],
        [106.907905615052, 47.9052821497515],
        [106.90779356582, 47.9052372672861],
        [106.907697975082, 47.9052003267337],
        [106.907631774187, 47.90517656035],
        [106.907462385081, 47.9051248079635],
        [106.907404300568, 47.9051047512833],
        [106.907282734711, 47.9050531283992],
        [106.907195015737, 47.9050227978639],
        [106.907040585954, 47.9049766860253],
        [106.906866449327, 47.9049252879717],
        [106.906725421241, 47.9048868275651],
        [106.906612759571, 47.9048583397406],
        [106.906527838389, 47.9048389035926],
        [106.906461690555, 47.9048233048517],
        [106.906425556694, 47.9048186580547],
        [106.906392225121, 47.9048188675967],
        [106.906356788235, 47.9048222382557],
        [106.906321631938, 47.9048286827975],
        [106.906288466739, 47.9048380033712],
        [106.90625924327, 47.9048496702761],
        [106.906227840742, 47.9048658310933],
        [106.906186826261, 47.9048966247794],
        [106.906171286875, 47.9049057825758],
        [106.906149130278, 47.9049149628553],
        [106.906128334355, 47.9049211268086],
        [106.906107659841, 47.9049247933446],
        [106.906085023905, 47.9049267232897],
        [106.906041444557, 47.9049250082825],
        [106.905997777076, 47.904920857012],
        [106.905974765223, 47.9049211411977],
        [106.905929007718, 47.9049244363138],
        [106.905863862627, 47.9049279562602],
        [106.905821318399, 47.9049273042518],
        [106.905783954266, 47.9049244066361],
        [106.905710932913, 47.9049109887512],
        [106.905612187353, 47.9048882448967],
        [106.905466328109, 47.904866282553],
        [106.905382522985, 47.9048488878659],
        [106.905257873352, 47.9048185384448],
        [106.905148031057, 47.9047910092977],
        [106.905074790269, 47.9047703716554],
        [106.905011269355, 47.9047497753819],
        [106.904931571435, 47.9047215438642],
        [106.904849755612, 47.9046909516261],
        [106.904780745235, 47.9046630879312],
        [106.904711603558, 47.9046321278704],
        [106.904599944632, 47.9045783079426],
        [106.90438991876, 47.9044710637886],
        [106.904308095742, 47.9044319738566],
        [106.904229936562, 47.9043986108073],
        [106.904050386017, 47.90432652385],
        [106.903934052415, 47.9042760359103],
        [106.90387728271, 47.9042538073673],
        [106.903827639234, 47.9042364036871],
        [106.903792856155, 47.904225948169],
        [106.903690578058, 47.9042056990338],
        [106.9036064204, 47.9041851504244],
        [106.90353322278, 47.9041668564154],
        [106.903434032055, 47.9041319267471],
        [106.903313096622, 47.9040973568076],
        [106.903210194395, 47.9040600502312],
        [106.903076259262, 47.9040092646159],
        [106.903015347281, 47.9039876916787],
        [106.902926356666, 47.9039574061094],
        [106.902872311008, 47.9039437346157],
        [106.90283341533, 47.9039376372123],
        [106.90278851218, 47.9039329328586],
        [106.902701355283, 47.9039295010457],
        [106.902581224744, 47.9039168619736],
        [106.902497424117, 47.9039060593172],
        [106.902387810249, 47.9038834917298],
        [106.902197571261, 47.903837879015],
        [106.90201955316, 47.9038008907985],
        [106.901941653884, 47.9037811605722],
        [106.901862986588, 47.9037556656915],
        [106.901769002937, 47.9037206254066],
        [106.901625343435, 47.9036596082044],
        [106.901555268261, 47.9036303010976],
        [106.901514925573, 47.9036151088503],
        [106.901472483868, 47.9036020030301],
        [106.901375694333, 47.9035759640595],
        [106.901221698922, 47.9035297478996],
        [106.901075257817, 47.90348907606],
        [106.901013655156, 47.9034704286174],
        [106.900957850425, 47.9034516579677],
        [106.900909906667, 47.9034325024081],
        [106.900817611044, 47.9033877017811],
        [106.900713994755, 47.903330898802],
        [106.900656813161, 47.9032951867235],
        [106.900617361702, 47.9032666638255],
        [106.900589978245, 47.9032420979445],
        [106.900534599792, 47.9031851303895],
        [106.900494697772, 47.9031445466836],
        [106.900470759618, 47.903125229246],
        [106.900448514887, 47.9031118383407],
        [106.900418953272, 47.9030968268571],
        [106.900356364055, 47.9030710423947],
        [106.900307379782, 47.9030546702369],
        [106.900250443703, 47.9030396101899],
        [106.900178390021, 47.9030233306622],
        [106.900049092692, 47.9029981019809],
        [106.899937902312, 47.9029763950447],
        [106.899888296608, 47.9029641876472],
        [106.899836802327, 47.9029466508673],
        [106.899741197199, 47.9029081032264],
        [106.899576611372, 47.9028402970421],
        [106.899498356864, 47.9028121509601],
        [106.899422534123, 47.9027906940353],
        [106.899275064193, 47.9027548866288],
        [106.89904006145, 47.9026923171967],
        [106.898973461256, 47.9026771060637],
        [106.898912811877, 47.9026657853977],
        [106.89885385682, 47.9026547839911],
        [106.898821677279, 47.9026526633897],
        [106.898797564656, 47.9026544899128],
        [106.89877474256, 47.9026583156288],
        [106.898750645226, 47.9026660776774],
        [106.898706868927, 47.9026862602627],
        [106.898630931073, 47.9027206440425],
        [106.898596218141, 47.902734418059],
        [106.898560572612, 47.9027473296256],
        [106.898538859381, 47.9027524350769],
        [106.898514398721, 47.9027542723918],
        [106.898488123228, 47.9027532741443],
        [106.898462276713, 47.9027484762613],
        [106.898418552574, 47.9027349189814],
        [106.898372033343, 47.9027193409249],
        [106.898278880666, 47.9026835847797],
        [106.898211617672, 47.9026566159101],
        [106.898175982935, 47.9026462728073],
        [106.898139921021, 47.9026404883679],
        [106.898103146843, 47.9026377238519],
        [106.898064353687, 47.9026379657695],
        [106.898030756814, 47.9026413598109],
        [106.89800985567, 47.9026466541198],
        [106.897966279021, 47.902662789756],
        [106.897948296177, 47.9026671056025],
        [106.897916307292, 47.9026703395646],
        [106.897879530416, 47.902670681307],
        [106.897850468824, 47.9026687360733],
        [106.897817654361, 47.9026643896499],
        [106.897740837869, 47.9026461531975],
        [106.897668001777, 47.9026376033428],
        [106.897570264356, 47.9026350762478],
        [106.897537270928, 47.9026324502274],
        [106.897492231082, 47.9026261136043],
        [106.897464255871, 47.9026190269466],
        [106.89744243562, 47.9026089941099],
        [106.89740502742, 47.9025858689428],
        [106.897295061918, 47.9025136992479],
        [106.897256504384, 47.9024907908174],
        [106.897188432001, 47.9024560176311],
        [106.897127348249, 47.9024295289996],
        [106.897070755711, 47.9024098068671],
        [106.896987946137, 47.9023855053868],
        [106.896863482664, 47.9023534247708],
        [106.896709496246, 47.9023072032149],
        [106.896535501712, 47.9022570812993],
        [106.896452880996, 47.9022309775776],
        [106.896402644866, 47.9022126260119],
        [106.896292474318, 47.9021690556574],
        [106.896243287698, 47.902151536864],
        [106.896146340781, 47.9021204446029],
        [106.896078340343, 47.9021030571104],
        [106.896026727352, 47.9020935126056],
        [106.895968909937, 47.9020853575533],
        [106.895902684761, 47.9020786036447],
        [106.89584162619, 47.9020752689585],
        [106.895773423405, 47.9020739199755],
        [106.89572928288, 47.9020771242599],
        [106.89569873291, 47.9020829392763],
        [106.895660962284, 47.9020928821808],
        [106.895607226892, 47.9021108380448],
        [106.895563633155, 47.902134220418],
        [106.89554668723, 47.902141098433],
        [106.895529250275, 47.9021459080073],
        [106.895510714348, 47.902149007071],
        [106.895491399609, 47.902150260726],
        [106.895470850999, 47.9021496653748],
        [106.895450627944, 47.9021469116507],
        [106.895423382983, 47.9021406946374],
        [106.895395441047, 47.9021320341661],
        [106.895346213057, 47.9021127104333],
        [106.895302070734, 47.9020938507506],
        [106.89528000317, 47.9020869808296],
        [106.895252792383, 47.9020826002319],
        [106.895221752282, 47.9020806280186],
        [106.895192681697, 47.9020816829234],
        [106.895149451286, 47.9020866984424],
        [106.895059386881, 47.9021028151928],
        [106.894911871985, 47.9021345099997],
        [106.894713977068, 47.902176789827],
        [106.894616200977, 47.902202101246],
        [106.894459077724, 47.902246831726],
        [106.894288397192, 47.9022962018083],
        [106.894154152692, 47.9023372045984],
        [106.894039808391, 47.9023758727484],
        [106.893989317753, 47.9023911297469],
        [106.893918346854, 47.9024090316515],
        [106.893852672963, 47.90242264379],
        [106.893803570878, 47.9024302871281],
        [106.89370833717, 47.9024420934279],
        [106.893397919079, 47.9024813497346],
        [106.893284576622, 47.9024950922748],
        [106.893220965775, 47.9025013371671],
        [106.89315886399, 47.9025048409257],
        [106.892989208685, 47.9025100363092],
        [106.892869806596, 47.9025190223351],
        [106.892562733084, 47.9025487656131],
        [106.892272732301, 47.9025674616191],
        [106.891705001984, 47.9025946022591],
        [106.891227256033, 47.9026195431575],
        [106.890951656094, 47.9026317028908],
        [106.890813304391, 47.9026412968584],
        [106.890744933432, 47.9026448761601],
        [106.890704650999, 47.902644914831],
        [106.890662043818, 47.9026420909598],
        [106.890622777619, 47.9026371186082],
        [106.890559732446, 47.9026235280534],
        [106.890463469913, 47.902594023995],
        [106.890350834324, 47.9025629623109],
        [106.890287521152, 47.9025420593686],
        [106.890224336584, 47.9025177632842],
        [106.890193844171, 47.9025088563986],
        [106.890163391328, 47.9025036601159],
        [106.890120059293, 47.9024990987544],
        [106.890035601262, 47.9024950032419],
        [106.889943257076, 47.9024983532165],
        [106.889837587635, 47.9025092350132],
        [106.889741936641, 47.9025170815981],
        [106.889642358308, 47.9025252501402],
        [106.889497853443, 47.902538444094],
        [106.889426845672, 47.90254810641],
        [106.889362102579, 47.9025590349715],
        [106.889302231113, 47.9025708070971],
        [106.889259774119, 47.902581116925],
        [106.889175855681, 47.9026090138949],
        [106.889019923131, 47.9026584927952],
        [106.888955523579, 47.9026792644366],
        [106.888920922163, 47.9026886767411],
        [106.88888760318, 47.9026962742137],
        [106.888863693804, 47.9026998166433],
        [106.888834491019, 47.90270113415],
        [106.888775705035, 47.9026992248894],
        [106.888696812008, 47.902698483848],
        [106.888626789894, 47.90269147723],
        [106.888599795844, 47.9026898305713],
        [106.888581880449, 47.902688737895],
        [106.888550853839, 47.9026886470635],
        [106.888522662791, 47.9026910167771],
        [106.888472332232, 47.9026980980389],
        [106.888359204714, 47.9027152013455],
        [106.888231143952, 47.9027387797709],
        [106.888161450091, 47.9027512974345],
        [106.888125782979, 47.9027609093885],
        [106.888099267367, 47.9027709152456],
        [106.888080977855, 47.9027800028949],
        [106.888065255907, 47.9027907102231],
        [106.888051479192, 47.9028029248152],
        [106.888034104291, 47.902825647086],
        [106.88800186989, 47.902856772622],
        [106.887971192217, 47.9028792610691],
        [106.887921871597, 47.9029090798901],
        [106.887862958809, 47.9029429591503],
        [106.8878206538, 47.9029617369946],
        [106.887787568641, 47.9029726637574],
        [106.88776061596, 47.9029790408501],
        [106.887739052915, 47.9029818557281],
        [106.887703164569, 47.9029840662617],
        [106.887662058357, 47.9029858801942],
        [106.887633441031, 47.902985211998],
        [106.887602383843, 47.9029823251742],
        [106.887581607705, 47.9029779059057],
        [106.887550774449, 47.9029641345872],
        [106.887516757592, 47.9029463370039],
        [106.887491617045, 47.9029222747432],
        [106.887466623086, 47.9029022882101],
        [106.887446562809, 47.9028925539483],
        [106.88741737801, 47.9028827018752],
        [106.887391455052, 47.9028759659531],
        [106.887365397195, 47.9028713182568],
        [106.887307649029, 47.9028681877168],
        [106.887216704188, 47.9028696832893],
        [106.887134926136, 47.9028730674382],
        [106.887041393945, 47.9028868432533],
        [106.886959987314, 47.9029004194189],
        [106.886867260016, 47.9029183995645],
        [106.886713777219, 47.9029556791613],
        [106.886662746089, 47.9029666338032],
        [106.886569287643, 47.9029824483814],
        [106.886518592859, 47.9029883524306],
        [106.886469542935, 47.9029922455957],
        [106.886354345177, 47.9029941386686],
        [106.886281234791, 47.9029967700849],
        [106.886233231678, 47.9030002090925],
        [106.886189778236, 47.9030053379261],
        [106.886133635359, 47.9030140829336],
        [106.886061321773, 47.9030275089125],
        [106.886023071807, 47.9030385301041],
        [106.885989379606, 47.9030511278074],
        [106.885959747844, 47.9030656221807],
        [106.885923945833, 47.903086876758],
        [106.885893889591, 47.903106689722],
        [106.885870709566, 47.9031244657216],
        [106.885848728336, 47.9031474532924],
        [106.885838475166, 47.9031555912576],
        [106.885817130656, 47.9031661735801],
        [106.885790635729, 47.9031747342266],
        [106.885766542892, 47.9031790123016],
        [106.885730227368, 47.9031818460654],
        [106.885688166975, 47.9031830250766],
        [106.885648300928, 47.9031811508895],
        [106.885596467603, 47.9031738438978],
        [106.885520014437, 47.9031567432891],
        [106.885394832406, 47.9031343222912],
        [106.885282880301, 47.9031206130259],
        [106.885108680721, 47.9031063866505],
        [106.884911037614, 47.9030933150045],
        [106.884841090144, 47.9030883453509],
        [106.88474992317, 47.9030837219363],
        [106.88461241683, 47.9030830222637],
        [106.884534927645, 47.9030801893993],
        [106.884451729564, 47.9030751442026],
        [106.884253336422, 47.9030574068739],
        [106.884115529708, 47.9030416624428],
        [106.8840639392, 47.9030389078194],
        [106.884025046219, 47.9030386461167],
        [106.883948270197, 47.903044408073],
        [106.883831363727, 47.9030563249894],
        [106.883704301213, 47.9030734759602],
        [106.883564768699, 47.903095985991],
        [106.883372323674, 47.9031303832606],
        [106.883157078137, 47.9031726334103],
        [106.88291721186, 47.9032256268612],
        [106.882750524317, 47.9032648786713],
        [106.882631891149, 47.9032955770293],
        [106.882554330018, 47.903315199337],
        [106.882515948752, 47.903328988642],
        [106.882491677849, 47.9033412482001],
        [106.882470013181, 47.9033544997105],
        [106.882440723161, 47.9033774872813],
        [106.882414938699, 47.9034049193016],
        [106.882360109731, 47.9034620856068],
        [106.882318788581, 47.9034972931656],
        [106.882275499715, 47.9035287442562],
        [106.882236091423, 47.9035530673203],
        [106.882222839912, 47.9035602556013],
        [106.88218697315, 47.9035797106352],
        [106.882123683361, 47.9036102767929],
        [106.882061810904, 47.9036357797674],
        [106.882002661594, 47.9036560028223],
        [106.881932733009, 47.9036761593273],
        [106.881873180803, 47.9036915179492],
        [106.881829846071, 47.9037003519897],
        [106.881783009378, 47.9037066697271],
        [106.881729815379, 47.9037109945668],
        [106.881662418386, 47.9037119703312],
        [106.88155227212, 47.903707152663],
        [106.881431516551, 47.9037001298572],
        [106.88129411633, 47.9036956296496],
        [106.881190901139, 47.9036946116171],
        [106.881022987821, 47.9036955702944],
        [106.880941624357, 47.9036977151775],
        [106.880760425353, 47.903707683263],
        [106.880680391987, 47.9037104306919],
        [106.880596101229, 47.903709543061],
        [106.880521200293, 47.9037037918965],
        [106.880447196881, 47.9036937509659],
        [106.880332399321, 47.9036663720055],
        [106.880254887653, 47.9036518866253],
        [106.8802095906, 47.9036469043812],
        [106.880164241387, 47.9036443691924],
        [106.880122787137, 47.903644686653],
        [106.880053928746, 47.9036484260341],
        [106.879937803787, 47.903657227699],
        [106.879767051308, 47.9036756314253],
        [106.879674710719, 47.9036871769217],
        [106.87945446765, 47.9037190030296],
        [106.879354032263, 47.9037319092003],
        [106.87921485678, 47.9037467929801],
        [106.87905720023, 47.9037615256739],
        [106.878756778103, 47.9037844493929],
        [106.878616520736, 47.9037934965727],
        [106.878553397321, 47.9037944966188],
        [106.878469247758, 47.9037936557527],
        [106.878298313616, 47.9037874504306],
        [106.878163144613, 47.9037804429132],
        [106.878097191033, 47.9037794869338],
        [106.878020274716, 47.9037824627905],
        [106.877943553552, 47.9037887526489],
        [106.877871384757, 47.9037976937087],
        [106.877803702679, 47.9038090467501],
        [106.877748833242, 47.9038207046618],
        [106.877693845994, 47.9038346270664],
        [106.877639083577, 47.9038507294277],
        [106.877584949786, 47.9038688921357],
        [106.87753835681, 47.9038853641183],
        [106.877512331329, 47.9038970876805],
        [106.877486686262, 47.9039130389556],
        [106.877460107698, 47.9039339553878],
        [106.877424612356, 47.9039705470032],
        [106.877395644294, 47.9040025295931],
        [106.877377879985, 47.9040157244462],
        [106.87736292336, 47.9040233210195],
        [106.877347373183, 47.9040270891789],
        [106.877312987604, 47.9040308897138],
        [106.877233108022, 47.9040434496455],
        [106.877036631335, 47.9040714212591],
        [106.876827015554, 47.904106358122],
        [106.876640901756, 47.9041431619774],
        [106.876488238242, 47.9041794181457],
        [106.876398727819, 47.9042033877762],
        [106.876344017562, 47.9042207213093],
        [106.876183804239, 47.9042766726304],
        [106.876036488094, 47.9043180486391],
        [106.875802428739, 47.9043751852666],
        [106.875715929247, 47.9043974758629],
        [106.875669672617, 47.9044066138742],
        [106.875592974836, 47.9044146187397],
        [106.875482661296, 47.9044186719842],
        [106.87540237432, 47.9044199840951],
        [106.875366723396, 47.9044245634429],
        [106.875325838417, 47.9044324882687],
        [106.875256237186, 47.9044516303385],
        [106.875156934045, 47.9044825121583],
        [106.875098809962, 47.9045055276081],
        [106.875031680967, 47.9045363239922],
        [106.874982009612, 47.9045611218983],
        [106.874942981733, 47.904582788365],
        [106.87485477173, 47.9046427470652],
        [106.874766071597, 47.90468920874],
        [106.874667130883, 47.9047373053824],
        [106.874554085203, 47.9047877879261],
        [106.874423803116, 47.904842828234],
        [106.874195860051, 47.9049348450671],
        [106.874016091869, 47.9050072737667],
        [106.87376354785, 47.9051062045878],
        [106.873327724695, 47.9052731178601],
        [106.87307998935, 47.9053649377417],
        [106.872937070889, 47.9054218189618],
        [106.872875335129, 47.905444802036],
        [106.8728085164, 47.9054670206865],
        [106.872733484163, 47.9054896764075],
        [106.872639334138, 47.905516192918],
        [106.872520869143, 47.9055473652188],
        [106.872353874931, 47.9055885901413],
        [106.871999700326, 47.9056684013757],
        [106.871657144062, 47.9057506497727],
        [106.871498519841, 47.9057868573776],
        [106.87127788017, 47.9058340412081],
        [106.871116394306, 47.9058651091875],
        [106.870983307234, 47.9058875346821],
        [106.870906315374, 47.9058958731961],
        [106.870793105118, 47.905904138865],
        [106.870697373185, 47.9059094340732],
        [106.870555822593, 47.9059147580597],
        [106.87043040404, 47.9059201953608],
        [106.870361871203, 47.9059201692804],
        [106.87029975503, 47.9059174056638],
        [106.870257839428, 47.9059128613895],
        [106.870219328659, 47.905905912328],
        [106.870190363295, 47.9058982060374],
        [106.870166240779, 47.9058884537891],
        [106.870125665167, 47.905867749597],
        [106.870075066611, 47.9058391295722],
        [106.87005060685, 47.9058284591162],
        [106.870020109041, 47.9058199065635],
        [106.869986477094, 47.9058137489054],
        [106.869942084759, 47.9058108890613],
        [106.869879342658, 47.9058132443858],
        [106.869833354026, 47.9058174927831],
        [106.869772694754, 47.9058262341934],
        [106.869649725954, 47.9058507443165],
        [106.869553031747, 47.9058613221424],
        [106.869467359631, 47.9058673224191],
        [106.869375081095, 47.9058703468391],
        [106.869274337241, 47.905870486234],
        [106.869158273436, 47.905867749597],
        [106.86908879721, 47.9058661892733],
        [106.869050977121, 47.9058627448698],
        [106.869010773828, 47.9058550376799],
        [106.868969958097, 47.9058438078455],
        [106.868891798917, 47.9058113189373],
        [106.868840402662, 47.9057955960899],
        [106.868773494901, 47.9057794838362],
        [106.868720883662, 47.9057681047143],
        [106.86868586586, 47.9057629048343],
        [106.868637928398, 47.9057604236047],
        [106.868588766958, 47.9057622348393],
        [106.868508882879, 47.9057747893751],
        [106.868452010652, 47.9057757147775],
        [106.868413493588, 47.9057759432052],
        [106.868391712907, 47.9057744449348],
        [106.868362487639, 47.9057690013384],
        [106.868307268366, 47.9057533126653],
        [106.868148413918, 47.9057108835505],
        [106.86801346435, 47.9056815701484],
        [106.867885447655, 47.9056588946423],
        [106.867786872966, 47.9056433912296],
        [106.86774062533, 47.9056342433257],
        [106.86766798439, 47.9056150643838],
        [106.867605270167, 47.9055936821028],
        [106.86755434156, 47.9055714814387],
        [106.867496275033, 47.9055414377872],
        [106.867422767147, 47.905499541071],
        [106.867398941408, 47.9054829962433],
        [106.867379779553, 47.9054668093459],
        [106.867357753358, 47.9054429404394],
        [106.867334265764, 47.9054112816054],
        [106.867291127084, 47.9053287067545],
        [106.867255893445, 47.9052797638501],
        [106.86722966112, 47.9052504846222],
        [106.867207276994, 47.9052310385816],
        [106.867183897319, 47.9052161619963],
        [106.867149191582, 47.9051982241188],
        [106.867105837065, 47.9051789822243],
        [106.86705749131, 47.905161452639],
        [106.867020835843, 47.9051512579243],
        [106.866925808979, 47.9051298342745],
        [106.866836590836, 47.9051046388681],
        [106.866763369834, 47.9050807088077],
        [106.866694452087, 47.9050533235521],
        [106.866562757166, 47.904993943116],
        [106.866413133359, 47.9049288537836],
        [106.866305699449, 47.9048866530966],
        [106.866206154391, 47.9048511928283],
        [106.866060880605, 47.9048050666006],
        [106.865999753686, 47.904788251077],
        [106.865942304993, 47.9047744572754],
        [106.865881619641, 47.9047621122817],
        [106.865816596859, 47.9047509642857],
        [106.865746203325, 47.9047407731682],
        [106.865669634146, 47.904731624365],
        [106.86548164796, 47.904716673136],
        [106.865372046683, 47.9047070126186],
        [106.865317160159, 47.9047035906982],
        [106.865209138091, 47.9047030699907],
        [106.865036230837, 47.90471040666],
        [106.864862515992, 47.9047199808425],
        [106.864748541312, 47.9047222947981],
        [106.864644987077, 47.9047212641751],
        [106.864512933325, 47.904715346636],
        [106.864396704944, 47.9047050404054],
        [106.864314059047, 47.904693994932],
        [106.864221696874, 47.9046786228202],
        [106.864104716659, 47.9046557269803],
        [106.864009161893, 47.9046325586457],
        [106.863937094721, 47.904612375161],
        [106.863890701395, 47.9045962197398],
        [106.863851944212, 47.9045786595775],
        [106.863798680964, 47.9045504487443],
        [106.863745090364, 47.9045167502479],
        [106.863720042446, 47.9045044601128],
        [106.863678884973, 47.9044925018276],
        [106.863615447695, 47.9044814005962],
        [106.863554920623, 47.9044744596287],
        [106.863474459179, 47.904470185151],
        [106.863402261605, 47.9044696248733],
        [106.863293810561, 47.9044731178402],
        [106.863209157377, 47.9044750918521],
        [106.863163504192, 47.9044797341525],
        [106.86312749174, 47.9044866760194],
        [106.863100428442, 47.9044942618008],
        [106.863075622442, 47.9045060600067],
        [106.863031892008, 47.9045362907173],
        [106.863011961233, 47.9045474638944],
        [106.862979073925, 47.9045611326902],
        [106.862942916682, 47.9045733337924],
        [106.862903967944, 47.904583905323],
        [106.862862954362, 47.904592645834],
        [106.862821084625, 47.9045994896748],
        [106.862786334822, 47.90460289181],
        [106.862753076993, 47.9046035114429],
        [106.862712655165, 47.9046018369053],
        [106.86267054441, 47.9045980516588],
        [106.862628618916, 47.9045919470607],
        [106.862602299357, 47.9045860178305],
        [106.862545369573, 47.9045696573638],
        [106.862520517708, 47.9045644421953],
        [106.862473201677, 47.9045582071956],
        [106.862436560599, 47.9045568015552],
        [106.862369896554, 47.9045646346502],
        [106.862321228842, 47.9045677274187],
        [106.862276307705, 47.9045684037089],
        [106.862189086957, 47.9045630662326],
        [106.862074781326, 47.904549166311],
        [106.861798928678, 47.9045108767756],
        [106.86167979009, 47.904493846314],
        [106.861617312389, 47.9044868136156],
        [106.861548930639, 47.9044825670169],
        [106.861422878963, 47.904478713422],
        [106.861253543816, 47.9044751071405],
        [106.861178266064, 47.9044714253161],
        [106.861070100105, 47.9044618484356],
        [106.860980005123, 47.9044498820564],
        [106.860923248909, 47.9044395011821],
        [106.860835026315, 47.9044207224384],
        [106.860711306582, 47.9043941465726],
        [106.860635876844, 47.9043744352321],
        [106.860580423748, 47.904358481259],
        [106.860551194882, 47.9043465481547],
        [106.860528663267, 47.9043329054393],
        [106.860506576817, 47.9043157607638],
        [106.86049312206, 47.9043021369341],
        [106.860468165873, 47.9042713702276],
        [106.860425563189, 47.9042220487086],
        [106.860398516978, 47.9041959737652],
        [106.860355145374, 47.9041645838285],
        [106.86029231334, 47.9041279229653],
        [106.860229589224, 47.9040960752737],
        [106.86016635879, 47.904069195437],
        [106.8601152746, 47.904051085789],
        [106.86006136474, 47.9040348854017],
        [106.859994208766, 47.9040167766529],
        [106.859950001691, 47.904009681002],
        [106.859915715938, 47.9040087430091],
        [106.859866369238, 47.9040110362803],
        [106.85978632328, 47.9040190852127],
        [106.859752420638, 47.9040183702517],
        [106.859695758852, 47.904013799897],
        [106.859604724978, 47.9040039613138],
        [106.859453605599, 47.9039817111871],
        [106.85931491665, 47.9039602245847],
        [106.859127015899, 47.9039284821138],
        [106.858993979189, 47.9039059082311],
        [106.858918156448, 47.9038913518045],
        [106.858840800363, 47.9038737952395],
        [106.858725702429, 47.9038449530822],
        [106.858643556555, 47.9038285854209],
        [106.858610004648, 47.9038203017656],
        [106.858580654374, 47.903811132278],
        [106.858556744998, 47.903800423151],
        [106.858533016386, 47.9037869827831],
        [106.858519059807, 47.9037762763541],
        [106.858509594442, 47.9037640743526],
        [106.858497700908, 47.9037406101411],
        [106.85847218984, 47.9036825040443],
        [106.858454343693, 47.9036474619609],
        [106.858439986916, 47.9036245067657],
        [106.858412228442, 47.9035921986211],
        [106.858363572421, 47.9035469699168],
        [106.858323686589, 47.9035113954346],
        [106.858294571937, 47.9034895688886],
        [106.858250140931, 47.90346400476],
        [106.858195706767, 47.9034394020068],
        [106.858141313971, 47.9034202896147],
        [106.858070483366, 47.9034009164192],
        [106.858013064351, 47.9033885858146],
        [106.857915471722, 47.9033719150819],
        [106.857806865095, 47.903356313643],
        [106.857760622855, 47.9033474130527],
        [106.85770820407, 47.9033327343183],
        [106.857625202041, 47.9033045900348],
        [106.857535617875, 47.9032712656564],
        [106.857499735824, 47.9032593550352],
        [106.857428954683, 47.9032408523835],
        [106.857344486759, 47.9032236051853],
        [106.857288029119, 47.9032131199896],
        [106.857253600373, 47.9032093212532],
        [106.857223141235, 47.9032093257498],
        [106.85716670428, 47.9032129769973],
        [106.857088128714, 47.9032173261187],
        [106.857036480649, 47.9032218371182],
        [106.85697252806, 47.9032309409552],
        [106.856873447052, 47.9032492322663],
        [106.856707310794, 47.9032834289871],
        [106.856570990659, 47.903308779077],
        [106.85644121579, 47.9033304959057],
        [106.856386733961, 47.903340058397],
        [106.856357988031, 47.9033430954076],
        [106.856327232116, 47.9033435342768],
        [106.856297692085, 47.9033418201689],
        [106.856255778282, 47.9033345860224],
        [106.856199794585, 47.9033186446398],
        [106.85616424978, 47.9033060010711],
        [106.85610133321, 47.9032797237803],
        [106.855982398769, 47.9032298797552],
        [106.855815907278, 47.9031605501194],
        [106.855716650903, 47.9031216049781],
        [106.855649655907, 47.9030979662982],
        [106.855543683394, 47.9030660349696],
        [106.855453620788, 47.9030448667273],
        [106.855407517043, 47.9030371172692],
        [106.855315661189, 47.9030245897131],
        [106.855158919249, 47.9030007576789],
        [106.855076780569, 47.9029901888462],
        [106.855011417843, 47.9029818296478],
        [106.854976022326, 47.9029805634023],
        [106.854948745888, 47.9029824510793],
        [106.854926002933, 47.9029858729997],
        [106.85490750208, 47.9029909667598],
        [106.854869777318, 47.9030047866416],
        [106.854825999221, 47.903019501349],
        [106.854793640714, 47.9030285251464],
        [106.854727136748, 47.9030408521537],
        [106.85468690018, 47.9030461230802],
        [106.854653781747, 47.9030487895701],
        [106.854607473856, 47.9030493552436],
        [106.85453988261, 47.9030461293754],
        [106.854427891834, 47.9030364068048],
        [106.854375148394, 47.903029160967],
        [106.854324741394, 47.903020344913],
        [106.854255604213, 47.903006063679],
        [106.854209958223, 47.902992938973],
        [106.854160646597, 47.9029734227853],
        [106.854124880559, 47.9029538013769],
        [106.854102003605, 47.9029365406889],
        [106.854083452389, 47.9029184589198],
        [106.854067779005, 47.9028983347904],
        [106.854058668873, 47.902880595663],
        [106.854054118303, 47.9028469097572],
        [106.854053289128, 47.9028233052514],
        [106.854056097711, 47.9028086148257],
        [106.854063133107, 47.9027958183724],
        [106.854078390106, 47.9027767464497],
        [106.854113900736, 47.9027401611296],
        [106.854126708881, 47.9027191286849],
        [106.854132605735, 47.9027015964016],
        [106.854132992444, 47.9026819093427],
        [106.854127895086, 47.9026634102882],
        [106.8541172642, 47.9026458267435],
        [106.854103354386, 47.9026322973427],
        [106.854086521776, 47.9026225891612],
        [106.854065912912, 47.9026148963604],
        [106.85404422576, 47.9026110535573],
        [106.854005457786, 47.9026091200149],
        [106.853973602, 47.9026086199919],
        [106.853895065105, 47.9026109033705],
        [106.853784512345, 47.902608187418],
        [106.853697456173, 47.9026073429546],
        [106.853614570156, 47.9026047367193],
        [106.853549943075, 47.9026007212464],
        [106.853478288692, 47.902594166088],
        [106.853428952784, 47.9025869202502],
        [106.85338012859, 47.9025755941884],
        [106.853310664955, 47.9025550689613],
        [106.853246555884, 47.9025335625739],
        [106.853137729822, 47.9024925912601],
        [106.852974144042, 47.9024310542498],
        [106.852866176833, 47.9023866888946],
        [106.852767742437, 47.9023426383022],
        [106.85269936968, 47.9023083561458],
        [106.852619481104, 47.9022603800126],
        [106.852504036032, 47.902180967178],
        [106.852394100208, 47.9021017162213],
        [106.852341000637, 47.9020628619116],
        [106.852314913103, 47.9020399732662],
        [106.852295038985, 47.9020159892465],
        [106.852262085127, 47.901966551715],
        [106.852205673353, 47.9018864374092],
        [106.852157625274, 47.9018080686875],
        [106.852077138649, 47.9016611887129],
        [106.851993320935, 47.9015042875928],
        [106.851951872081, 47.9014336377522],
        [106.851909583261, 47.9013697238337],
        [106.851835462936, 47.9012667118893],
        [106.851800601617, 47.9012186206429],
        [106.851785983137, 47.9011932372781],
        [106.851776174231, 47.9011696138866],
        [106.851771077773, 47.9011507128352],
        [106.851769794441, 47.9011147228662],
        [106.851769227868, 47.9010872350879],
        [106.851771613769, 47.9010719304253],
        [106.851780342589, 47.9010518899328],
        [106.851793666045, 47.901033311738],
        [106.851804993905, 47.9010231368084],
        [106.851834030316, 47.9009531398756],
        [106.851802046827, 47.9008601328889],
        [106.851758265132, 47.9007637462499],
        [106.85171034026, 47.9006702824076],
        [106.851657069818, 47.9005474089358],
        [106.851570573923, 47.9004426550045],
        [106.851464437734, 47.9003244292291],
        [106.851404711958, 47.9002630900696],
        [106.851397058727, 47.9002544089139],
        [106.851390447811, 47.9002385619601],
        [106.851385900839, 47.9002048751549],
        [106.851382932177, 47.9001216473962],
        [106.851368289415, 47.8999613324496],
        [106.851354828363, 47.899849618665],
        [106.851341639805, 47.8997772043546],
        [106.851325836019, 47.8997100079106],
        [106.851310948641, 47.8996674142198],
        [106.851296905728, 47.8996388868252],
        [106.851271586215, 47.8995960260358],
        [106.851240229553, 47.8995464140358],
        [106.851201397726, 47.89949216693],
        [106.851148167754, 47.8994223120901],
        [106.851032654334, 47.8992780266597],
        [106.850956247933, 47.8991804619088],
        [106.850923583657, 47.8991289883122],
        [106.850904885852, 47.8990907743199],
        [106.850894416844, 47.8990619366591],
        [106.850889333876, 47.8990368797483],
        [106.85088548118, 47.8989990605582],
        [106.850883817434, 47.8989625912507],
        [106.850885181706, 47.8989221262552],
        [106.85089027007, 47.8988594273208],
        [106.85089857441, 47.8988030389291],
        [106.850906928212, 47.8987632700089],
        [106.850906524417, 47.8987443914406],
        [106.850899727341, 47.8987250182451],
        [106.850888434554, 47.8987064220637],
        [106.850870422932, 47.8986886172859],
        [106.850833312407, 47.8986622959283],
        [106.850801846028, 47.8986415737497],
        [106.850765133005, 47.8986206312372],
        [106.85072042141, 47.8985977416925],
        [106.850666120345, 47.8985727117613],
        [106.850585997946, 47.8985396301998],
        [106.850472729233, 47.8984993045993],
        [106.850347903333, 47.8984588998584],
        [106.850225741225, 47.898424511582],
        [106.85013209482, 47.8984011049271],
        [106.850051050616, 47.8983829413198],
        [106.849976028271, 47.898368552167],
        [106.849905402712, 47.8983576523838],
        [106.84982280358, 47.8983478407803],
        [106.84975089199, 47.8983421363806],
        [106.849673407302, 47.8983392288724],
        [106.849606898839, 47.898339953726],
        [106.849525434651, 47.8983456779107],
        [106.849450165893, 47.8983559841414],
        [106.849411047182, 47.8983623441469],
        [106.849390357379, 47.8983682023307],
        [106.849370592979, 47.8983777153594],
        [106.849354284673, 47.8983890387232],
        [106.849345170044, 47.8983988692125],
        [106.849331911339, 47.8984186587941],
        [106.849297628283, 47.8984768880979],
        [106.849284461309, 47.8984959474301],
        [106.849269514577, 47.8985154330408],
        [106.849258744296, 47.898525620561],
        [106.849244563786, 47.8985347109082],
        [106.849229198868, 47.8985418524246],
        [106.849206835427, 47.8985483194494],
        [106.849182690429, 47.8985516028742],
        [106.849162209269, 47.8985518942546],
        [106.849145814628, 47.8985499472224],
        [106.849130989304, 47.8985448138921],
        [106.849108380348, 47.8985325444414],
        [106.849063853114, 47.8985040026576],
        [106.849012635825, 47.8984755687925],
        [106.84896857444, 47.898449929121],
        [106.848944376382, 47.8984384061076],
        [106.848911177909, 47.898426773377],
        [106.848880100037, 47.8984191839982],
        [106.848853455822, 47.8984156595551],
        [106.848816304829, 47.8984134598133],
        [106.84873267957, 47.8984148069978],
        [106.848695879311, 47.8984116368876],
        [106.848668805221, 47.8984068318099],
        [106.848640258042, 47.8983974725654],
        [106.848604288757, 47.8983808629865],
        [106.848549568608, 47.8983479837725],
        [106.848464576379, 47.8983008889749],
        [106.848413561437, 47.8982780776712],
        [106.848375871749, 47.8982663666995],
        [106.848340085926, 47.8982590048492],
        [106.848272170025, 47.8982550343424],
        [106.848211781449, 47.8982509424271],
        [106.848161367253, 47.8982450006063],
        [106.848118237567, 47.8982321915624],
        [106.84800671264, 47.8982019140871],
        [106.847898057449, 47.8981817198106],
        [106.847776859415, 47.8981617251835],
        [106.847640306355, 47.8981335386319],
        [106.84750357523, 47.8981002906959],
        [106.847428827179, 47.8980783859088],
        [106.847297967727, 47.8980360791018],
        [106.847145976905, 47.897988235169],
        [106.84706177608, 47.8979588543177],
        [106.846988669292, 47.8979302351922],
        [106.846926774351, 47.8979036332461],
        [106.846878267618, 47.8978807805736],
        [106.84686109956, 47.897871055305],
        [106.846852580282, 47.8978643130876],
        [106.846841884645, 47.8978459165559],
        [106.846820916052, 47.8978209342887],
        [106.846795108208, 47.8978010934458],
        [106.846773359003, 47.89779066131],
        [106.84674164621, 47.8977800088404],
        [106.846708658178, 47.8977722072216],
        [106.846658259271, 47.8977644703541],
        [106.84660952501, 47.897759030355],
        [106.846542438283, 47.8977545166577],
        [106.846439401157, 47.8977511100257],
        [106.846306500245, 47.8977549357418],
        [106.846226222262, 47.8977562271682],
        [106.84618018237, 47.8977543278],
        [106.846145704161, 47.897750770082],
        [106.846074859167, 47.8977350292483],
        [106.845969414557, 47.8977154438127],
        [106.845824879115, 47.8976934706772],
        [106.84570129338, 47.8976768907759],
        [106.845640147575, 47.8976715443064],
        [106.845585532646, 47.8976686233084],
        [106.845480106921, 47.8976686314023],
        [106.845392423022, 47.8976734157956],
        [106.845297572425, 47.8976884452656],
        [106.845224999834, 47.8976946748694],
        [106.845174959757, 47.8976947297281],
        [106.8451194536, 47.8976913078077],
        [106.845073939811, 47.8976856303876],
        [106.845000825828, 47.8976729589399],
        [106.844917438889, 47.8976574177557],
        [106.844848924938, 47.897636575068],
        [106.844795882024, 47.897627298561],
        [106.844742231169, 47.8976240780888],
        [106.844635204651, 47.897626505359],
        [106.844565025156, 47.8976249207536],
        [106.844529780725, 47.8976265107549],
        [106.844504972926, 47.8976289290319],
        [106.844489821148, 47.8976322169533],
        [106.844475871764, 47.8976377468846],
        [106.844447892956, 47.8976531468753],
        [106.844415209794, 47.8976687537101],
        [106.844376548839, 47.8976848030113],
        [106.844316730433, 47.8977058957105],
        [106.844287487178, 47.8977147459388],
        [106.84426948365, 47.8977184709307],
        [106.844247166074, 47.897720038449],
        [106.844219309574, 47.8977192776226],
        [106.844193140201, 47.8977165976429],
        [106.844166327814, 47.8977116891432],
        [106.844123199926, 47.8976988774013],
        [106.844067289974, 47.8976795185949],
        [106.844024282595, 47.8976700811094],
        [106.844002329244, 47.897668253687],
        [106.843986592008, 47.897668999225],
        [106.843954337822, 47.8976796453994],
        [106.8439296937, 47.8976860422771],
        [106.843911989647, 47.8976887654242],
        [106.843889412167, 47.897689127851],
        [106.843880144653, 47.8976861699808],
        [106.843858766869, 47.8976744284322],
        [106.843842734655, 47.8976690369965],
        [106.843823286815, 47.8976648704375],
        [106.843788045082, 47.8976620600561],
        [106.843747905641, 47.89766270487],
        [106.843653162963, 47.8976690091175],
        [106.843466166031, 47.8976810150668],
        [106.843290636354, 47.897692607328],
        [106.8431890957, 47.8977012192359],
        [106.843078946736, 47.8977130516161],
        [106.842992461633, 47.897724632186],
        [106.842929526177, 47.8977343169852],
        [106.842889329179, 47.8977420430609],
        [106.842847678877, 47.897752685638],
        [106.842779984209, 47.8977730579803],
        [106.842702504917, 47.8977990393942],
        [106.842667452941, 47.8978086252679],
        [106.842621783569, 47.8978170384256],
        [106.842567584127, 47.8978237320796],
        [106.842516878551, 47.8978268887],
        [106.842423831095, 47.8978282907431],
        [106.842303412772, 47.8978302233862],
        [106.842245130409, 47.8978276261441],
        [106.842192709826, 47.8978229964342],
        [106.842071493804, 47.8978024352343],
        [106.841994869767, 47.8977920219843],
        [106.841910139242, 47.8977825170496],
        [106.841681964151, 47.8977659209605],
        [106.841574302712, 47.8977567973384],
        [106.841513998672, 47.8977483589996],
        [106.841457625569, 47.8977368206978],
        [106.84141611736, 47.8977251717793],
        [106.84137720999, 47.8977105092327],
        [106.841344756156, 47.8976948070697],
        [106.84132219936, 47.8976803693536],
        [106.841286376665, 47.8976529796014],
        [106.841230474807, 47.8976061923719],
        [106.841207130205, 47.8975889802473],
        [106.841167107676, 47.897564592432],
        [106.841128601404, 47.8975452246324],
        [106.841077323859, 47.8975261257302],
        [106.840999977667, 47.8975045249139],
        [106.840928968097, 47.8974885340687],
        [106.840807880679, 47.8974670933317],
        [106.840693216219, 47.8974474818159],
        [106.840592448982, 47.8974322850719],
        [106.840456437315, 47.8974146871382],
        [106.840350498976, 47.8974046543014],
        [106.840246716313, 47.8973994301396],
        [106.840115954887, 47.8973971602508],
        [106.84000338315, 47.8973976431868],
        [106.839891845632, 47.8974007530423],
        [106.839841060916, 47.8974040841312],
        [106.839707041247, 47.8974167250019],
        [106.839667205777, 47.8974185883972],
        [106.839631419954, 47.8974184310158],
        [106.839575636806, 47.8974152069463],
        [106.83951394871, 47.8974090600801],
        [106.839419852644, 47.8973926870229],
        [106.83938604443, 47.8973886023022],
        [106.839337054761, 47.8973867973629],
        [106.839278927081, 47.8973880681049],
        [106.839223791445, 47.8973919333911],
        [106.839165518974, 47.8973988878484],
        [106.839103125809, 47.897409864074],
        [106.839022642781, 47.8974281850627],
        [106.838959853914, 47.8974456723799],
        [106.838833090875, 47.8974876293507],
        [106.838777668355, 47.8975041328096],
        [106.838687266704, 47.8975287598444],
        [106.838631685904, 47.8975402315965],
        [106.838576475624, 47.8975467930501],
        [106.838504895884, 47.897551266278],
        [106.838407894109, 47.8975528194072],
        [106.838303881219, 47.8975454809392],
        [106.838134376101, 47.8975310369279],
        [106.837995483005, 47.8975162817511],
        [106.837870390906, 47.89749942306],
        [106.837756028618, 47.8974799797173],
        [106.837677052854, 47.8974658171937],
        [106.837634657014, 47.8974549147126],
        [106.837595481646, 47.8974412378229],
        [106.837570146845, 47.8974289386947],
        [106.837547070241, 47.8974118380859],
        [106.837525229306, 47.8973891445934],
        [106.837514941961, 47.8973738938901],
        [106.837496638959, 47.8973378355727],
        [106.837466615992, 47.8972898135741],
        [106.837440094984, 47.8972532138648],
        [106.837409917334, 47.8972168308921],
        [106.83738434691, 47.8971910859999],
        [106.837349793158, 47.8971628400931],
        [106.837315617122, 47.8971404199945],
        [106.837290974799, 47.8971277584394],
        [106.837261820577, 47.8971155528405],
        [106.837226148068, 47.8971027743736],
        [106.837179911224, 47.8970885749778],
        [106.837125108337, 47.8970738341902],
        [106.837048264866, 47.897056922439],
        [106.836954247041, 47.8970402687934],
        [106.836847760116, 47.8970273113614],
        [106.836735230646, 47.8970180087741],
        [106.836520967169, 47.8970045899899],
        [106.836376696128, 47.8969935283287],
        [106.836334233738, 47.8969920282595],
        [106.836296300334, 47.8969924275585],
        [106.836217560192, 47.8969988972813],
        [106.836099667166, 47.8970158306162],
        [106.835953156813, 47.8970446781694],
        [106.835896820582, 47.8970528350204],
        [106.835845527749, 47.8970567263869],
        [106.835783253295, 47.8970591527577],
        [106.835676491177, 47.8970590574296],
        [106.835446739575, 47.8970551228957],
        [106.83530466288, 47.8970507503919],
        [106.834871921702, 47.8970336956486],
        [106.834732642797, 47.8970300650855],
        [106.834607765636, 47.8970285200502],
        [106.834447996578, 47.8970264093414],
        [106.834362651815, 47.8970287745583],
        [106.834296953642, 47.8970324518862],
        [106.834259471697, 47.8970377488931],
        [106.834224382849, 47.8970474822556],
        [106.834178716175, 47.8970646817897],
        [106.834093034166, 47.8971063473801],
        [106.834023295339, 47.897136766049],
        [106.833980189934, 47.8971545429479],
        [106.833953427908, 47.8971635253765],
        [106.83390988903, 47.8971727443267],
        [106.833850505896, 47.8971798219912],
        [106.833782811228, 47.8971825028702],
        [106.833676166022, 47.8971789442529],
        [106.833599613931, 47.8971745159912],
        [106.833474085661, 47.897163856327],
        [106.833240879763, 47.897144548782],
        [106.83316746001, 47.8971359215856],
        [106.833102334705, 47.8971258347895],
        [106.833001980257, 47.8971047438889],
        [106.832827672759, 47.8970606186527],
        [106.832612740186, 47.8970072303994],
        [106.832475064772, 47.8969713069803],
        [106.832350428629, 47.8969361201059],
        [106.832239210371, 47.8969015060997],
        [106.832128618041, 47.896863291208],
        [106.831946797607, 47.8967962773264],
        [106.831858253955, 47.8967619358148],
        [106.831814331067, 47.8967471059942],
        [106.831737764586, 47.8967257560888],
        [106.831708976388, 47.8967198601335],
        [106.83168251024, 47.8967162412616],
        [106.831634044875, 47.8967145649253],
        [106.831557296732, 47.8967182377565],
        [106.831416138244, 47.8967314802737],
        [106.831357313589, 47.8967339588052],
        [106.831291938272, 47.8967344363452],
        [106.831100123672, 47.8967291950963],
        [106.830971359641, 47.896724360341],
        [106.830870956629, 47.8967181981864],
        [106.830745011073, 47.8967053441763],
        [106.830526301348, 47.8966760721431],
        [106.830332072967, 47.8966494728949],
        [106.830017162762, 47.8966035993766],
        [106.829628125937, 47.8965490815749],
        [106.829455991201, 47.8965236037814],
        [106.829289427765, 47.896497199686],
        [106.829140952393, 47.8964710366091],
        [106.829003446052, 47.8964452458515],
        [106.828916068822, 47.8964269977078],
        [106.828815331263, 47.8964056118296],
        [106.82878666897, 47.8963977283725],
        [106.828762217303, 47.8963891542361],
        [106.828732000981, 47.8963752687038],
        [106.828679009329, 47.8963465209752],
        [106.828543580422, 47.8962726182867],
        [106.828428870096, 47.8962039766323],
        [106.828356882964, 47.8961570778869],
        [106.828287052406, 47.8961086520927],
        [106.828219378422, 47.8960586992496],
        [106.828153860113, 47.896007220257],
        [106.826396933772, 47.894547644858],
        [106.824338642814, 47.8928508840611],
        [106.822648235728, 47.8913659154047],
        [106.822269585173, 47.8910332822602],
        [106.820290680071, 47.8893127847572],
        [106.81794047907, 47.8872576126487],
        [106.81592097857, 47.8855108000834],
        [106.814332576187, 47.8841178500588],
        [106.814277722939, 47.8840748615656],
        [106.814219956786, 47.884034256276],
        [106.814159278628, 47.8839960305924],
        [106.814095689365, 47.883960187213],
        [106.814019306346, 47.8839227223558],
        [106.81391280773, 47.8838766087186],
        [106.813808441406, 47.8838339979407],
        [106.813719044299, 47.8838003731887],
        [106.813635865103, 47.8837724519372],
        [106.813557019741, 47.883749647828],
        [106.813485378847, 47.8837324563878],
        [106.813404672787, 47.883716425073],
        [106.813314879978, 47.8837013236572],
        [106.813177550803, 47.883680703102],
        [106.813089052118, 47.8836686746697],
        [106.812989720199, 47.8836573513058],
        [106.812652880926, 47.8836255800565],
        [106.812449135919, 47.8836068858491],
        [106.812001972313, 47.883569320268],
        [106.81181907539, 47.8835522772159],
        [106.811532526205, 47.8835226877219],
        [106.811253945014, 47.8834917582381],
        [106.810982546707, 47.8834593988322],
        [106.810717752123, 47.8834255420552],
        [106.810588093266, 47.8834071940868],
        [106.81025176121, 47.883356130581],
        [106.810063210249, 47.8833321033939],
        [106.809833431668, 47.8833097876167],
        [106.80960766766, 47.8832931699439],
        [106.809507057805, 47.8832881067607],
        [106.809394914144, 47.8832846425723],
        [106.809010128415, 47.8832797385691],
        [106.808861526239, 47.883276108006],
        [106.808458175804, 47.8832594048977],
        [106.808293816606, 47.8832535440159],
        [106.808209193999, 47.8832460337775],
        [106.808144850205, 47.8832355746621],
        [106.808076295784, 47.8832208032975],
        [106.808002119702, 47.883201452585],
        [106.807915382789, 47.8831757229812],
        [106.807832834917, 47.8831486030257],
        [106.807756084975, 47.883120161966],
        [106.807685123969, 47.8830903998021],
        [106.807619969886, 47.8830593210309],
        [106.807572374166, 47.8830338207543],
        [106.807524471777, 47.88300569086],
        [106.807427334204, 47.8829412994015],
        [106.807383706293, 47.8829084966298],
        [106.807338323805, 47.8828708995724],
        [106.807224128791, 47.8827657976036],
        [106.807121024216, 47.8826673281347],
        [106.807089555139, 47.8826330576695],
        [106.807064151989, 47.8826011470254],
        [106.807038182266, 47.8825608897733],
        [106.806991224166, 47.8824754748633],
        [106.806908997352, 47.8823217753297],
        [106.806882583365, 47.8822815126817],
        [106.806854736757, 47.882247042567],
        [106.806819018383, 47.8822090012445],
        [106.806786463824, 47.8821778712119],
        [106.806754351732, 47.8821510561264],
        [106.806722058876, 47.8821280766494],
        [106.806659359042, 47.882091859152],
        [106.806591184136, 47.8820609629431],
        [106.806534436015, 47.8820428496978],
        [106.806425189971, 47.8820177055527],
        [106.806383629601, 47.882006583637],
        [106.806278441297, 47.8819719156714],
        [106.80614937959, 47.881923801942],
        [106.806038288137, 47.8818794761569],
        [106.805949389253, 47.8818404806537],
        [106.805774892897, 47.8817509936135],
        [106.805671273011, 47.8817052082288],
        [106.80557490166, 47.8816676723253],
        [106.805492462607, 47.8816404534442],
        [106.805351147637, 47.8815991349921],
        [106.805132783251, 47.8815385431693],
        [106.804774571589, 47.8814467952334],
        [106.804564122137, 47.8813939339829],
        [106.804328352272, 47.8813367523892],
        [106.80350723617, 47.8811439017697],
        [106.803363019088, 47.8811111133872],
        [106.803006826404, 47.8810350640171],
        [106.802845159776, 47.8809986450715],
        [106.802676217633, 47.8809562501309],
        [106.802528064219, 47.8809133299862],
        [106.802362975671, 47.8808632071713],
        [106.802284498131, 47.8808375666005],
        [106.802209913757, 47.880809559014],
        [106.802146428815, 47.8807809740628],
        [106.802086217405, 47.8807499564454],
        [106.802037237628, 47.8807221628975],
        [106.801995328322, 47.880695227303],
        [106.801959724162, 47.8806686136656],
        [106.801925063391, 47.8806383289958],
        [106.801893323618, 47.8806063500031],
        [106.80186513257, 47.8805733134078],
        [106.80184100286, 47.8805398163595],
        [106.801827344856, 47.8805162730076],
        [106.801814945004, 47.8804891458574],
        [106.80177857732, 47.8803870746038],
        [106.801760789629, 47.8803378241313],
        [106.801745211572, 47.8802848576601],
        [106.801731704655, 47.8802277273278],
        [106.801720062931, 47.8801655670873],
        [106.801702579211, 47.8800328226567],
        [106.801678900961, 47.8797641403029],
        [106.80166644625, 47.8796538852187],
        [106.801647431884, 47.8795419519996],
        [106.801622684339, 47.8794466976071],
        [106.801603569249, 47.8793930170741],
        [106.801581552047, 47.8793438052725],
        [106.801556470854, 47.8792986952786],
        [106.801528196169, 47.8792574586648],
        [106.801496556221, 47.879219863406],
        [106.801461480863, 47.879185847449],
        [106.801431509157, 47.8791621413198],
        [106.801388889386, 47.8791388893483],
        [106.801349225686, 47.879111457328],
        [106.801315098213, 47.8790959826935],
        [106.801278177446, 47.8790817221438],
        [106.801238353667, 47.8790686334108],
        [106.801149563602, 47.8790458239057],
        [106.801046953654, 47.8790270928261],
        [106.800950266642, 47.8790143728151],
        [106.800838048337, 47.8790034838238],
        [106.800418484925, 47.8789753503322],
        [106.800249587748, 47.8789604611564],
        [106.800163179088, 47.878950032618],
        [106.800084423657, 47.8789380842252],
        [106.800011940099, 47.8789244028389],
        [106.799945053921, 47.8789088616547],
        [106.79986428311, 47.878887589091],
        [106.799782548226, 47.878868493786],
        [106.799690430669, 47.8788501790925],
        [106.799353680428, 47.8787941189535],
        [106.799218444875, 47.8787683326924],
        [106.798937890571, 47.8787064197655],
        [106.798827503287, 47.8786795642106],
        [106.798726986961, 47.8786530593912],
        [106.798574536586, 47.8786102363734],
        [106.798458678725, 47.8785752005851],
        [106.798356243246, 47.8785409463077],
        [106.798264916193, 47.8785065778164],
        [106.798182217236, 47.87847134058],
        [106.798093873234, 47.8784296012452],
        [106.797998956986, 47.8783811718537],
        [106.79786197495, 47.8783079301669],
        [106.797788707183, 47.8782672331463],
        [106.797708804218, 47.8782203200118],
        [106.797379723396, 47.8780182900121],
        [106.796602539176, 47.877569296286],
        [106.796442816883, 47.8774707350864],
        [106.796115677696, 47.8772572818981],
        [106.795972073053, 47.8771668892406],
        [106.795815570332, 47.8770757987092],
        [106.795741480585, 47.8770361655866],
        [106.795668872021, 47.8769997673255],
        [106.795575606929, 47.8769562338431],
        [106.79546940419, 47.8769097343968],
        [106.795112292398, 47.8767625207737],
        [106.794716027723, 47.8765963962068],
        [106.794592025602, 47.8765475549258],
        [106.794478886392, 47.8765059756703],
        [106.794321362041, 47.8764520559177],
        [106.794169453957, 47.8764034079909],
        [106.794022021799, 47.8763596712619],
        [106.79387841086, 47.8763206496783],
        [106.79372475989, 47.8762833619876],
        [106.793555529064, 47.8762470581553],
        [106.793366528443, 47.8762107354372],
        [106.793126756595, 47.8761684250329],
        [106.792867304882, 47.8761274132495],
        [106.792583585864, 47.8760894672552],
        [106.792268389675, 47.8760534781855],
        [106.791872349829, 47.8760137973989],
        [106.791569215347, 47.8759780070794],
        [106.791465735755, 47.8759677089426],
        [106.791349721413, 47.875961203247],
        [106.791296683895, 47.8759607266063],
        [106.791246031379, 47.8759620845826],
        [106.791182816234, 47.8759661782965],
        [106.791113381377, 47.8759729780705],
        [106.790927379095, 47.8759978011577],
        [106.790810825159, 47.8760177346308],
        [106.790537915992, 47.8760757022319],
        [106.790412927315, 47.876098059378],
        [106.790240709841, 47.8761251199784],
        [106.790187606673, 47.8761307047683],
        [106.790139948, 47.876133060992],
        [106.790076349744, 47.8761318019411],
        [106.790006118987, 47.8761258592211],
        [106.789928511092, 47.8761153974077],
        [106.789818822581, 47.8760970773183],
        [106.789745882167, 47.8760830254113],
        [106.789667120441, 47.8760649589308],
        [106.789580900638, 47.8760426125766],
        [106.789465486143, 47.8760103529954],
        [106.789307281906, 47.8759614397687],
        [106.789080292122, 47.8758831331002],
        [106.788991448996, 47.8758501882356],
        [106.788763684896, 47.8757602218568],
        [106.788695466822, 47.875735854726],
        [106.788632790371, 47.8757158897765],
        [106.788514229148, 47.8756801012557],
        [106.788447816913, 47.8756619349504],
        [106.788384012712, 47.8756477508431],
        [106.788325483934, 47.8756386946701],
        [106.788259676043, 47.8756321988669],
        [106.788200577095, 47.8756289649049],
        [106.788146429814, 47.875628898355],
        [106.788096766553, 47.8756320100093],
        [106.788035999362, 47.8756414151193],
        [106.787930356901, 47.8756653460789],
        [106.787773353258, 47.8757071888357],
        [106.787736964889, 47.8757150273267],
        [106.787703753825, 47.8757201156908],
        [106.787666594738, 47.8757233856258],
        [106.78762462068, 47.8757249180705],
        [106.787490613601, 47.8757234350885],
        [106.787353847402, 47.8757233532502],
        [106.787312885981, 47.8757209547583],
        [106.787277121742, 47.875716511208],
        [106.787228422554, 47.8757059297849],
        [106.787176142265, 47.875689448809],
        [106.787121747671, 47.8756681034003],
        [106.787030362162, 47.8756281213407],
        [106.786970240684, 47.8756005697106],
        [106.786908529205, 47.8755692939878],
        [106.786844676441, 47.8755340162819],
        [106.786777325313, 47.8754939928535],
        [106.786712709924, 47.8754512013119],
        [106.786650191753, 47.8754033366947],
        [106.786589101706, 47.8753498971801],
        [106.786528217603, 47.8752898143735],
        [106.786482426823, 47.8752402554335],
        [106.786434097256, 47.8751843167029],
        [106.78624305967, 47.8749470737485],
        [106.786155276845, 47.8748455798597],
        [106.786063722263, 47.8747392323298],
        [106.785879467364, 47.8745044688063],
        [106.78579530431, 47.8744037924012],
        [106.785746295755, 47.8743502719475],
        [106.78569796439, 47.8743016707855],
        [106.785649332651, 47.874257011352],
        [106.785599881629, 47.874215818805],
        [106.785457370561, 47.8741026634072],
        [106.78536614693, 47.8740373087749],
        [106.785320398418, 47.8740085259727],
        [106.785275712005, 47.8739834124046],
        [106.785231441078, 47.8739616074423],
        [106.785187232205, 47.8739429357179],
        [106.785104826427, 47.8739151376735],
        [106.785009187124, 47.8738905277257],
        [106.784898619975, 47.8738685240132],
        [106.784756903009, 47.8738458880773],
        [106.784644395123, 47.873831363127],
        [106.784530554442, 47.8738209300919],
        [106.784415378267, 47.8738145871735],
        [106.784305554858, 47.8738055561815],
        [106.78430511419, 47.8738055471883],
        [106.784255781879, 47.8755965434458],
        [106.784234699971, 47.8765062508629],
        [106.78423496707, 47.8765124570843],
        [106.784234945486, 47.8765133887819],
        [106.784278098555, 47.8775159691867],
        [106.784433358413, 47.8784816045425],
        [106.784672404508, 47.8801089026038],
        [106.784841635333, 47.8812268606312],
        [106.784938974354, 47.8820291206475],
        [106.785014852853, 47.882714374369],
        [106.785116576969, 47.8849129002102],
        [106.785201128529, 47.8868652816075],
        [106.78529511218, 47.8893455389655],
        [106.785373433237, 47.8911161376997],
        [106.785441538896, 47.8930968342515],
        [106.785441784411, 47.8931039721706],
        [106.785529727315, 47.8950798771347],
        [106.78555537598, 47.8960214826054],
        [106.785555557643, 47.8960262777905],
        [106.785555621495, 47.8960286214238],
        [106.785639418524, 47.8982403852856],
        [106.785724392767, 47.9009352505614],
        [106.785724439531, 47.9009360986221],
        [106.785724638281, 47.9009423893798],
        [106.785826090801, 47.9027669015713],
        [106.785882090686, 47.9041704680927],
        [106.785903950507, 47.9054794718002],
        [106.785904135767, 47.9054830007399],
        [106.785904196022, 47.9054866106186],
        [106.785971592115, 47.9067705861937],
        [106.78608333288, 47.9073888889861],
        [106.788383063028, 47.9075914621763],
        [106.78969297595, 47.9077185354821],
        [106.791247879486, 47.9078693544871],
        [106.794770801831, 47.9081576969202],
        [106.797681181541, 47.9084087039985],
        [106.799457777854, 47.9085421481017],
        [106.800327197442, 47.9086221634821],
        [106.80080165817, 47.9086927593634],
        [106.800973604049, 47.9087420871777],
        [106.801455287232, 47.9090206692685],
        [106.80175955486, 47.9092056076527],
        [106.802056052345, 47.9093858218982],
        [106.80229995388, 47.9095016509805],
        [106.80248036058, 47.9095716551079],
        [106.802737381425, 47.9096196438315],
        [106.803047818402, 47.909645984075],
        [106.805215064923, 47.9096312109117],
        [106.80722516391, 47.9096115139603],
        [106.811914381943, 47.9096104329752],
        [106.814180280496, 47.9097931545305],
        [106.817842468255, 47.910073385978],
        [106.821768920899, 47.9103857268199],
        [106.826238438153, 47.9107361170782],
        [106.829613125246, 47.910978926836],
        [106.832965373353, 47.9112428059108],
        [106.836744125841, 47.9115309801706],
        [106.840266958254, 47.9118023218198],
        [106.843711929162, 47.9120591978738],
        [106.845760550609, 47.9122187735776],
        [106.849492657061, 47.9124968709339],
        [106.854861111451, 47.9128611125503],
        [106.854999810293, 47.9164454406047],
        [106.855035147354, 47.9173586409885],
        [106.854893649822, 47.9173790358139],
        [106.854887595586, 47.9173799081563],
        [106.852749745205, 47.9176595289641],
        [106.852761846482, 47.9176651173514],
        [106.852750000612, 47.9176666668832],
        [106.853104518759, 47.9178303812672],
        [106.853191548851, 47.9178992045847],
        [106.853215394375, 47.918028150279],
        [106.853122572649, 47.9184750647724],
        [106.852815238333, 47.9196203972636],
        [106.852582163736, 47.9213129771123],
        [106.852450156749, 47.9226534768765],
        [106.852385194221, 47.9230417591699],
        [106.851993324532, 47.9230748344361],
        [106.851994371343, 47.9230819058054],
        [106.85199357904, 47.9230819723552],
        [106.852164040138, 47.9242329687765],
        [106.852722222353, 47.9242500001375],
        [106.85288958079, 47.9254619571037],
        [106.853327502962, 47.9257424889248],
        [106.853409091257, 47.9260785466876],
        [106.853428727054, 47.9269041791846],
        [106.853428821483, 47.92690454341],
        [106.853428982462, 47.9269113171037],
        [106.85361367623, 47.9276239920537],
        [106.853707788484, 47.9283080325897],
        [106.853806130249, 47.9292495049608],
        [106.854008001068, 47.9303030103757],
        [106.854395468576, 47.9318150144514],
        [106.854470400089, 47.9321014044563],
        [106.855232161835, 47.932808097116],
        [106.855780206891, 47.9335215841538],
        [106.855928470922, 47.9341880249575],
        [106.856829771477, 47.9351767072393],
        [106.857358936166, 47.9356396791279],
        [106.857552773342, 47.9361883330252],
        [106.858102266307, 47.9368014611186],
        [106.85862066791, 47.9377963253402],
        [106.858627977599, 47.9377923773164],
        [106.859292482162, 47.9380725943748],
        [106.859526555906, 47.9382159472083],
        [106.859779993852, 47.938760287957],
        [106.859739796854, 47.939720721634],
        [106.860540771739, 47.9408213569201],
        [106.861100953147, 47.9413139066115],
        [106.860784238002, 47.9433054849602],
        [106.860769827266, 47.9441517982669],
        [106.862455034472, 47.9442314862941],
        [106.862666666533, 47.9443611109766],
        [106.86296011082, 47.9443649411891],
        [106.863324570073, 47.9443904513583],
        [106.863703358223, 47.9443414508973],
        [106.864563335829, 47.9440760906391],
        [106.864752277096, 47.9439710192472],
        [106.865790007503, 47.9437804816839],
        [106.866274440813, 47.9435954866424],
        [106.866705822216, 47.9433542165239],
        [106.867182487182, 47.9431307781629],
        [106.867573068143, 47.9431144257901],
        [106.867652907256, 47.9431459479272],
        [106.867690392797, 47.9431416060004],
        [106.867768120303, 47.9431391715356],
        [106.867897545335, 47.9431534716554],
        [106.868501193675, 47.9430893266112],
        [106.868988342038, 47.942911450603],
        [106.869201645939, 47.9428649052912],
        [106.869292874067, 47.9428285582914],
        [106.869871586005, 47.9424582255667],
        [106.870157583905, 47.9423674390061],
        [106.870482681631, 47.9422265647042],
        [106.870944187624, 47.9419650841214],
      ],
    ],
  },
};
